import React from 'react';
import { Card, Brow, Text } from '@highereducation/hen-ui';
import { parseHtmlString } from '@de/shared/utils';
import type { TextBoxConfig } from '@de/types/types';

const TextBox: React.FC<TextBoxConfig> = ({
  text = 'Online programs can cut the time it takes to get your degree by 50%.',
  title = 'Did You Know?',
}) => {
  return (
    <Card className='w-full' variant='background-white'>
      <Card.Content>
        <Brow>{title}</Brow>
        <Text variant='b4' color='subtext'>
          {parseHtmlString(text)}
        </Text>
      </Card.Content>
    </Card>
  );
};

export default TextBox;
